import { useState } from "react";
import {
  validateName,
  restrictedTermsError
} from "../../../utils/validateName";
import $ from "jquery";

export const useEditEntityName = (onSuccess?: () => void) => {
  const [entityNameDraft, setEntityNameDraft] = useState<string>("");
  const [isInEditMode, setIsInEditMode] = useState<boolean>(false);

  const toggleEditMode = (
    enterEditMode: boolean,
    name: string,
    e?: React.MouseEvent
  ) => {
    if (e) {
      e.stopPropagation();
    }
    if (enterEditMode) {
      $('.tooltip').remove();
      setIsInEditMode(true);
      setEntityNameDraft(name);
    } else {
      setIsInEditMode(false);
    }
  };

  const hasInvalidatedValues = (toastrValue: boolean, value: string) => {
    const entityName =
      value !== undefined && value !== null ? value : entityNameDraft;
    const editInputContainer = document.querySelector(".ws-edit-album-name");

    if (!validateName(entityName) && editInputContainer) {
      //@ts-ignore
      editInputContainer.style.outline = "red 1px solid";
      if (toastrValue) {
        //@ts-ignore
        toastr.error(restrictedTermsError);
      }
      return true;
    }

    if (entityName.trim() === "" && editInputContainer) {
      //@ts-ignore
      editInputContainer.style.outline = "red 1px solid";
      if (toastrValue) {
        //@ts-ignore
        toastr.error("Please enter a name");
      }
      return true;
    }

    if (
      validateName(entityName) &&
      entityName.trim() !== "" &&
      editInputContainer
    ) {
      //@ts-ignore
      editInputContainer.style.outline = "";
    }
    return false;
  };

  const updateDraftName = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
    setEntityNameDraft(e.target.value);
    hasInvalidatedValues(false, e.target.value);
  };

  const handleKeyDownAction = (
    e: React.KeyboardEvent<HTMLTextAreaElement>,
    onSubmit: () => Promise<void>
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (entityNameDraft.trim() !== "") {
        onSubmit();
      } else {
        hasInvalidatedValues(true, entityNameDraft);
      }
    }
  };

  const submitNameChange = async (
    e: React.MouseEvent,
    onSubmit: () => Promise<void>
  ) => {
    e.stopPropagation();
    if (hasInvalidatedValues(true, entityNameDraft)) {
      return;
    }
    if (entityNameDraft.trim() !== "") {
      await onSubmit();
    }
  };

  return {
    isInEditMode,
    entityNameDraft,
    toggleEditMode,
    updateDraftName,
    handleKeyDownAction,
    submitNameChange,
    hasInvalidatedValues
  };
};
